(()=>{
  const initialise=()=>{
    document.querySelectorAll('[data-dtr-root]').forEach(root=>{
      if(root.dataset.ready)return;
      root.dataset.ready='true';
      const demo=root.querySelector('.dtr-demo'),label=root.querySelector('[data-dtr-shade]');
      root.querySelectorAll('[data-dtr-colour]').forEach(button=>button.addEventListener('click',()=>{
        root.querySelectorAll('[data-dtr-colour]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
        const colour=button.dataset.dtrColour;
        demo.classList.toggle('dtr-running',colour==='rainbow');
        demo.style.setProperty('--dtr-glow',colour==='rainbow'?'#c69aff':colour);
        label.textContent=button.textContent.trim();
      }));
      const main=document.querySelector('.dtr-summary')?.closest('[id^="shopify-section-"]'),form=main?.querySelector('form[data-product-id="'+root.dataset.productId+'"]');
      const sticky=root.querySelector('[data-dtr-sticky]'),price=root.querySelector('[data-dtr-price]');
      if(form){
        const observed=form.querySelector('[type="submit"]')||form;
        if('IntersectionObserver'in window){
          let passed=false;
          const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
            passed=!entry.isIntersecting&&entry.boundingClientRect.bottom<0;
            sticky.hidden=!passed;
          }),{threshold:0});
          observer.observe(observed);
        }
        root.querySelector('.dtr-choose').addEventListener('click',()=>{
          const scope=form.closest('.product-form')||main||form.parentElement;
          const picker=scope.querySelector('variant-picker')||scope.querySelector('.option-selector')||form;
          picker.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
          const focusTarget=picker.querySelector('select,input:not([type="hidden"]),button');
          if(focusTarget)setTimeout(()=>focusTarget.focus({preventScroll:true}),350);
        });
      }
      function sync(){
        const nativePrice=main?.querySelector('.price__default .price__current');
        if(nativePrice)price.textContent=nativePrice.textContent.trim();
      }
      const nativePriceContainer=main?.querySelector('.price-container');
      if(nativePriceContainer)new MutationObserver(sync).observe(nativePriceContainer,{subtree:true,childList:true,characterData:true});
      ['change','variant:change','product:variant-change'].forEach(event=>document.addEventListener(event,()=>setTimeout(sync,100)));
      document.addEventListener('click',event=>{
        const link=event.target.closest('[data-dtr-order]');
        if(!link)return;
        const id=form?.querySelector('[name="id"]')?.value;
        const url=new URL(root.dataset.productUrl,location.origin);
        if(id)url.searchParams.set('variant',id);
        link.href='https://wa.me/917077719844?text='+encodeURIComponent(root.dataset.orderText+' '+root.dataset.productTitle+' — '+url.href);
      });
      sync();
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialise);else initialise();
  document.addEventListener('shopify:section:load',initialise);
})();
